import { ActivityIndicator } from "@components/ActivityIndicator";
import { BodySmall } from "@components/Typography";
import { useDeleteInviteToShareGoal, useErrorBanner } from "@hooks";
import { i18n, Translations } from "@i18n";
import { useStyles } from "@routes/ShareGoalRoute/InviteContactList/InviteContactItem/styles";
import { RemoveInviteCTAProps } from "./types";

export const RemoveInviteCTA = ({ id, goalId }: RemoveInviteCTAProps) => {
  const styles = useStyles();

  const { showErrorBanner } = useErrorBanner();

  const [deleteInvite, { loading }] = useDeleteInviteToShareGoal({ goalId });

  const onClick = async () => {
    try {
      await deleteInvite({
        variables: {
          shareGoalInviteId: id,
        },
      });
    } catch {
      showErrorBanner();
    }
  };

  if (loading) {
    return (
      <div style={styles.loader}>
        <ActivityIndicator />
      </div>
    );
  }

  return (
    <div style={styles.cta} onClick={onClick}>
      <BodySmall style={styles.remove}>{i18n.t(Translations.InviteItemRemoveLabel)}</BodySmall>
    </div>
  );
};
